const getAssetUrl = (assets, locale, assetLink) => {
    if (!assetLink)
        return "";
    const asset = assets[assetLink.sys.id];
    return asset?.fields.file[locale]?.url
        ? `https:${asset.fields.file[locale].url}`
        : "";
};
export { getAssetUrl };
//# sourceMappingURL=contentful.js.map